module.exports = __webpack_public_path__ + "img/bishop-henry-mcneal-turner.4aa66cc9.png";